// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';

// Import componenets
import LoadingSpinner from '../../../reusables/spinner';

// Import configuration from .json file
import config from '../../../../configs/config.json';
const AUTH_URL = config.AUTH_URL;

class ForgotPasswordPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            loading: false,
            noMemberFound: false,
            sent: false,
            error: false,
            message: ''
        };
    }

    componentDidMount = () => {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        var user_type = cookie.get('user-type');

        if (token) {
            if (user_type === 'member') {
                // If user logged in is a member, re-direct them to the videos menu
                window.location.href = '/videos';
            } else if (user_type === 'admin') {
                // IF user logged in is an admin, re-direct them to the login history page
                window.location.href = '/admin/history';
            }
        }

        document.addEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            // When the [ENTER] key is pressed, fire off the back-end auth call
            this.submitRequest();
        }
    }

    emailIsValid = () => {
        // Verify the email entered is valid
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email);
    }

    handleChange = (field) => (event) => {
        var updatedState = this.state;
        updatedState[field] = event.target.value;
        this.setState({ updatedState });
    }

    submitRequest = () => {
        if (this.emailIsValid()) {
            this.setState({ loading: true });
            console.log('valid email');
            axios.post(`${AUTH_URL}/forgot`, { email: this.state.email })
                .then(response => {
                    console.log(response.data);
                    console.log(response.data.noMemberFound);

                    var noMemberFound = (response.data.noMemberFound) ? response.data.noMemberFound : false;
                    var sent = (noMemberFound) ? false : true;

                    this.setState({ loading: false, sent, noMemberFound });
                    console.log('state ', this.state);
                })
                .catch(error => {
                    console.log(error);
                    this.setState({ loading: false, error: true });
                })
        } else {
            this.setState({ message: 'Not a valid email address. Please enter your email address.' })
        }
    }

    handleBackButton = () => {
        window.location.reload();
    }

    render() {
        if (this.state.error) {
            return (
                <div className='container'>
                    <div className='alert alert-danger'>
                        <p>Server Error</p>
                    </div>
                </div>
            );
        }
        else if (this.state.loading) {
            return (
                <LoadingSpinner message='Sending request, please wait..' />
            );
        }
        else if (this.state.noMemberFound) {
            return (
                <div className='container'>
                    <div className='alert alert-danger'>
                        <p>This email does not exist on the OLLI video website... Try again or call the OLLI office at (949) 451-1403 for help.</p>
                        <button className='btn btn-secondary' onClick={this.handleBackButton}>Back</button>
                    </div>
                </div>
            );
        }
        else if (this.state.sent) {
            return (
                <div className='container'>
                    <div className='alert alert-success'>
                        <p>Password reset link sent to {this.state.email}</p>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className='container'>
                    <div className='card'>
                        <div className='card-body'>
                            <h2 style={{ textAlign: 'center', color: 'black', fontSize: 24, fontWeight: 'bold', marginBottom: 16 }} className='card-title'>Forgot Password</h2>
                            <p>Please enter and submit your email address to emailed password recovery instructions.</p>
                            <input className='form-control' type='text' placeholder='Email' value={this.state.email} onChange={this.handleChange('email')} />


                            {(this.state.message) ? <div style={{ marginTop: 15 }} className='alert alert-danger'>{this.state.message}</div> : ''}

                            <div style={{ textAlign: 'center' }}>
                                <button className='btn btn-secondary' style={{ marginTop: 15, marginRight: 15 }} onClick={() => window.location.href = '/login'}>Return to Log In</button>
                                <button style={{ marginTop: 15, marginLeft: 15 }} className='btn btn-primary' onClick={this.submitRequest}>Send Email</button>
                            </div>

                        </div>
                    </div>

                </div>
            );
        }


    }
};

export default ForgotPasswordPage;
